module.exports = __webpack_public_path__ + "img/title.131f8a31.png";